import { render, staticRenderFns } from "./PaginaNaoEncontrada.vue?vue&type=template&id=52322a72&scoped=true&"
import script from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js&"
export * from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js&"
import style0 from "./PaginaNaoEncontrada.vue?vue&type=style&index=0&id=52322a72&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52322a72",
  null
  
)

export default component.exports